<template>
    <svg fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 2 L14.5 13.5 L1.5 13.5 Z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round" fill="none" />
        <rect x="7.25" y="5.5" width="1.5" height="4.5" rx="0.75" fill="currentColor" />
        <circle cx="8" cy="11.75" r="0.85" fill="currentColor" />
    </svg>
</template>
